import {DataSharing} from './data.sharing';

export class PermissionHelperModule {
    public static DecodeData(key, list) {
        const split_key = key.split('.');
        if (split_key.length > 1) {
            let temp = null;
            let value = null;
            for (let i = 0; i < split_key.length; i++) {
                if (typeof temp === 'object' && temp !== null) {
                    temp = temp[split_key[i]];
                }
                if (typeof temp === 'string') {
                    value = temp;
                }
                if (temp === null) {
                    temp = list[split_key[i]];
                }
            }
            return value;
        }
        if (list[key]) {
            return list[key];
        }
        return '';
    }

    public static CheckPermissionExist(permission) {
        let return_val = false;
        const user_permission = DataSharing.user_permissions();
        user_permission.forEach(function (val, key) {
            if (permission === val.name) {
                return_val = true;
                return true;
            }
        });
        return return_val;
    }

    public static CheckRole(roles) {
        let return_val = false;
        const user_role = DataSharing.user_role();
        for (let i = 0; i < roles.length; i++) {
            if (user_role === roles[i].id) {
                return_val = true;
                return true;
            }
        }
        return return_val;
    }

    /** check email **/
    public static CheckEmail(email) {
        const EMAIL_REGEXP = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
        return EMAIL_REGEXP.test(email);
    }

    /** check email **/
    public static CheckInteger(no) {
        const NO_REGEXP = /^[0-9]/;
        return NO_REGEXP.test(no);
    }

    public static UpdateUrlState(url: string) {
        return history.pushState(null, null, url);
    }
}
